import { serviceCoinList } from "@/global/variable";

export default {
  namespaced: true,
  state: {
    list: serviceCoinList,
    selectedIndex: 0,
  },
  getters: {
    GT_BS_LIST: (state) => state.list,
    GT_BS_CURRENT_COIN: (state) => {
      const selectInfo = state.list[state.selectedIndex];
      const coinNameUSDT = selectInfo.name + "USDT";
      const coinName = selectInfo.name;
      const icon = selectInfo.icon;
      return {
        coinNameUSDT,
        coinName,
        icon,
        selectedIndex: state.selectedIndex,
      };
    },
  },
  mutations: {
    MU_BS_SELECT: (state, payload) => {
      state.selectedIndex = payload;
    },
  },
};
